<template>
    <div class="turntable lottery-box">
        <div class="mask2" v-if="showToast"></div>
        <div class="lottery-alert" v-if="showToast">
            <h1>恭喜您</h1>
            <p><img :src="luckyProduct.prize_image" alt=""></p>
            <h2>获得{{luckyProduct.name}}</h2>
            <div class="btnsave" @click="setShowToast()">好的</div>
        </div>
        <div class="turntableBg">
            <!--恭喜xxx获得xxx 滚动条-->
<!--            <div class="winPrize acea-row row-center-wrapper">-->
<!--                <div class="pictrue"><img src="@assets/images/horn1.png"></div>-->
<!--                <div class="swiper-no-swiping new-banner">-->
<!--                    <swiper class="swiper-wrapper" :options="swiperRoll" v-if="history.length > 0">-->
<!--                        <swiper-slide class="swiper-slide" v-for="(item, index) in history" :key="index">-->
<!--                            <div class="text acea-row row-between-wrapper">-->
<!--                                <div class="newsTitle line1">{{ item.nickname }}{{item.remark}}</div>-->
<!--                            </div>-->
<!--                        </swiper-slide>-->
<!--                    </swiper>-->
<!--                </div>-->
<!--            </div>-->       
            <section class="lottery_pool">
              <div class="chance">获得 <span>{{configData.user.now_num}}次</span> 抽奖机会</div>
              <div class="turntableCon_parent">
                <div class="turntableCon">
                    <div class="diskCenter on box" @click="startLottery" v-if="isStart==1">
                        <img src="@assets/images/clickT.png">
                    </div>
                    <div class="diskCenter on box" v-else>
                      <div class="process">进行中</div>
                    </div> 
                    <div class="item" v-for="(item,i) in list" :key="i" :class="i==index?'on':''">
                        <div class="itemCon acea-row row-center-wrapper">
                            <div class="border">
                                <div class="pictrue">
                                    <img src="@assets/images/hide_prizes.png" alt=""></div>
                                <!-- <div class="name">{{item.name}}</div> -->
                                <div class="name">现金红包</div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
            </section>
        </div>
<!--      中奖记录-->
<!--        <div class="wrapper">-->
<!--            <div class="border">-->
<!--                <div class="title acea-row row-center-wrapper">-->
<!--                    <div class="name">中奖记录</div>-->
<!--                </div>-->
<!--                <div class="list">-->
<!--                    <div class="header acea-row row-middle">-->
<!--                        <div class="num">昵称</div>-->
<!--                        <div class="name">奖品名称</div>-->
<!--                        <div class="time">获奖时间</div>-->
<!--                    </div>-->
<!--                    <div class="item acea-row row-middle" v-for="(item,i) in history" :key="i">-->
<!--                        <div class="num">{{item.nickname}}</div>-->
<!--                        <div class="name">{{item.remark}}</div>-->
<!--                        <div class="time">{{item.add_time}}</div>-->
<!--                    </div>-->
<!--                    <div v-if="!loadend && !loading && history.length >= 10" class="is_loading" @click="getLotteryHistory()"> 加载更多 >> </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
        <div class="wrapper" v-if="false">
            <div class="border">
                <div class="title acea-row row-center-wrapper">
                    <div class="name">活动奖品</div>
                </div>
                <div class="conter">
                  <div class="item" v-for="(item,i) in list" :key="i" v-if="item.is_good=='1'">
                    <div class="pictrue">
                        <img :src="item.prize_image" alt="">
                    </div>
                    <div class="name">{{item.name}}</div>
                    <!-- <div class="name">价值 ￥{{item.prize_money}}</div> -->
                  </div>
                </div>
            </div>
        </div>
        <div class="wrapper">
            <div class="border">
                <div class="title acea-row row-center-wrapper">
                    <div class="name">活动说明</div> 
                </div>
                <div class="conter" v-html="configData.content">

                </div>
            </div>
        </div>
        <!---->
        <div class="copyright">本活动最终解释权归 {{configData.author}} 所有</div>
    </div>
<!--    </div>-->
</template>
<style scoped>
.process {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 0.4rem;
  color: #ffcda4;
}
.turntable .wrapper .conter {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.turntable .wrapper .conter .item {
  width: 2rem;
  /* height: 2.4rem; */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
}
.turntable .wrapper .conter .item .pictrue {
  width: 2rem;
  /* height: 2rem; */
}
.turntable .wrapper .conter .item .pictrue img {
  width: 100%;
  height: 100%;
}
.turntable .wrapper .conter .item .pictrue + .name {
  margin-top: 0.1rem;
}
.turntable .wrapper .conter .item .name {
  font-size: 0.24rem;
  text-align: center;
  line-height: 1.5;
}
.turntable .turntableCon .item .border{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  align-content: center;
}
.turntable .turntableCon .item .border .name{
  margin-top: 0.1rem;
}
.turntable .turntableCon .item .border .pictrue{
  width: 1.2rem;
  height: auto;
}
.turntable .turntableCon .item .border .pictrue img{
  height: auto;
}
</style>
<script>
import "@assets/css/lottery.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { getConfig, getLuckPrize, getLuckHistory } from "@api/lottery";
import { wechatEvevt } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { mapGetters } from "vuex";

import { getUserInfo } from "@api/user";
export default {
  name: "Lottery",
  inject: ['reload'],
  components: { swiper, swiperSlide },
  computed: {
    ...mapGetters(["isLogin"]),
  },
  data: function () {
    return {
      configData: {
        user: {
          now_num: 0
        }
      },
      isStart: 1,
      score: 10, //消耗积分
      list: [], //奖品1-9
      index: -1, // 当前转动到哪个位置，起点位置
      sort:  -1, // 当前转动到哪个位置，起点位置
      count: 8, // 总共有多少个位置
      timer: 0, // 每次转动定时器
      speed: 200, // 初始转动速度
      times: 0, // 转动次数
      cycle: 50, // 转动基本次数：即至少需要转动多少次再进入抽奖环节
      prize: -1, // 中奖位置
      luckyProduct: {}, // 抽中的产品
      click: true,
      showToast: false, //显示中奖弹窗
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000,
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
      },
      history: [],
      loading: false,
      loadend: false,
      id: 1,
      where: {
        page: 1,
        limit: 10,
        money: 0,
        id: 1,
      },
    };
  },
  mounted () {
    this.$nextTick(() => {
      this.getLotteryConfig();
      this.getLotteryHistory();
    })
  },
  beforeDestroy () {
    this.getLotteryHistory();
  },
  methods: {
    setShowToast () {
      this.reload();
      this.showToast = false;
    },
    getLotteryConfig() {
      var that = this;
      getConfig(this.id).then((res) => {
        that.setOpenShare();
        that.configData = Object.assign({}, that.configData, res.data);

        that.list = res.data.prizeList;
      })
      .catch(err => {
        that.$dialog.error(err.msg);
        return that.$router.push({path: '/user'})
      });
    },
    getLotteryHistory() {
      var that = this;
      if(that.loadend || that.loading) return;
      that.loading = true;
      getLuckHistory(this.where).then((res) => {
        let loadend = res.data.data.length < that.where.limit
        that.history = that.history.concat(res.data.data);
        console.log(this.history,"history")
        that.where.page += 1
        that.loadend = loadend
        that.loading = false
      });
    },
    startLottery() {
      let createtime = (new Date().getTime() / 1000).toFixed(0);
      if (this.isStart == 0) {
        return;
      }
      if (this.configData.store_lottery.start_time > createtime) {
        return this.$dialog.error("活动尚未开始");
      }
      if (this.configData.store_lottery.stop_time < createtime) {
        return this.$dialog.error("活动已结束");
      }
      var that = this;
      if (that.configData.user.now_num < 1) {
        return this.$dialog.error("您当前没有抽奖次数");
      }
      this.isStart = 0;
      if (!this.click) {
        return;
      }
      getLuckPrize(this.id)
        .then((res) => {
          if (res.status != 200) {
            return;
          }
          that.configData.user.now_num -= 1;
          that.prize = res.data.prize;
          that.list.forEach((item, index) => {
            if(item.id == that.prize) {
              that.sort = index;
              that.luckyProduct = item;
            }
          });
          this.startRoll();
        })
        .catch((res) => {
          this.$dialog.error(res.msg);
          that.isStart = 1;
        });
    },
    // 开始转动
    startRoll() {
      this.times += 1; // 转动次数
      this.oneRoll(); // 转动过程调用的每一次转动方法，这里是第一次调用初始化
      // 如果当前转动次数达到要求 && 目前转到的位置是中奖位置
      if (this.times > this.cycle + 10  && this.sort === this.index) {
        clearTimeout(this.timer); // 清除转动定时器，停止转动
        this.prize = -1;
        this.times = 0;
        this.speed = 200;
        this.click = true;
        var that = this;
        setTimeout((res) => {
          that.where.page = 1;
          that.where.loading = false;
          that.where.loadend = false;
          that.history.splice(0,this.history.length);
          that.showToast = true;
          that.isStart = 1;
          that.getLotteryHistory();
        }, 500);
      } else {
        if (this.times < this.cycle) {
          this.speed -= 10; // 加快转动速度
        } else if ( this.times > this.cycle + 10 && this.prize === 0 && this.index === 7) {
          this.speed += 110;
        } else {
          this.speed += 20;
        }
        if (this.speed < 40) {
          this.speed = 40;
        }
        this.timer = setTimeout(this.startRoll, this.speed);
      }
    },

    // 每一次转动
    oneRoll() {
      let index = this.index; // 当前转动到哪个位置
      const count = this.count; // 总共有多少个位置
      index += 1;
      if (index > count - 1) {
        index = 0;
      }
      this.index = index;
    },
    setOpenShare: function () {
      var data = this.configData;
      var href = location.href;
      if (isWeixin()) {
        if (this.isLogin) {
          getUserInfo().then((res) => {
            href =
              href.indexOf("?") === -1
                ? href + "?spread=" + res.data.uid
                : href + "&spread=" + res.data.uid;
            var configAppMessage = {
              desc: data.synopsis,
              title: data.title,
              link: href,
              imgUrl: data.image_input[0],
            };
            wechatEvevt(
              [
                "updateAppMessageShareData",
                "updateTimelineShareData",
                "onMenuShareAppMessage",
                "onMenuShareTimeline",
              ],
              configAppMessage
            )
              .then((res) => {
                console.log(res);
              })
              .catch((res) => {
                if (res.is_ready) {
                  res.wx.updateAppMessageShareData(configAppMessage);
                  res.wx.onMenuShareAppMessage(configAppMessage);
                  res.wx.updateTimelineShareData(configAppMessage);
                  res.wx.onMenuShareTimeline(configAppMessage);
                }
              });
          });
        } else {
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: href,
            imgUrl: data.image_input[0],
          };
          wechatEvevt(
            [
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareAppMessage",
              "onMenuShareTimeline",
            ],
            configAppMessage
          )
            .then((res) => {
              console.log(res);
            })
            .catch((res) => {
              if (res.is_ready) {
                res.wx.updateAppMessageShareData(configAppMessage);
                res.wx.onMenuShareAppMessage(configAppMessage);
                res.wx.updateTimelineShareData(configAppMessage);
                res.wx.onMenuShareTimeline(configAppMessage);
              }
            });
        }
      }
    },
  },
};
</script>